import Dexie, { Table } from "dexie";
import { SuggestionSearchMode } from "../types/enums";

export type SearchHistory = {
  id?: number;
  userId: number | string;
  workspaceId: string;
  workspaceName: string;
  searchText: string;
  keywordSearchText: string;
  tags: Array<string>;
  searchType: SuggestionSearchMode;
  searchTypeName: string;
  timestamps: string | Date;
};

export class LocalDbStore extends Dexie {
  // Search History Table
  histories!: Table<SearchHistory>;

  constructor(dbName: string) {
    super(dbName);
    this.version(2).stores({
      histories: "++id, userId, workspaceId",
      anomalies: "++id, userId, workspaceId",
    });
    this.version(3).stores({
      anomalies: null,
    });
  }
}

export const localDbStore = new LocalDbStore("smart_drafter_db");
